export default function LoaderImg(){
    return (
        <div className="loader-img-comp">
            <img src="/assets/images/load.svg"/>
        </div>
    )
}